import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrPaginationV2Component } from './pr-pagination-v2.component';

@NgModule({
  declarations: [PrPaginationV2Component],
  imports: [CommonModule],
  exports: [PrPaginationV2Component],
})
export class PrPaginationV2Module {}
